/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Colleague_List_CountInputs */

const en_colleague_list_count = /** @type {(inputs: Colleague_List_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tickets`)
};

const ja_colleague_list_count = /** @type {(inputs: Colleague_List_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`チケット ${i?.count} 件`)
};

const fr_colleague_list_count = /** @type {(inputs: Colleague_List_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tickets`)
};

const de_colleague_list_count = /** @type {(inputs: Colleague_List_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Tickets`)
};

/**
* | output |
* | --- |
* | "{count} tickets" |
*
* @param {Colleague_List_CountInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_list_count = /** @type {((inputs: Colleague_List_CountInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_List_CountInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_list_count(inputs)
	if (locale === "ja") return ja_colleague_list_count(inputs)
	if (locale === "fr") return fr_colleague_list_count(inputs)
	return de_colleague_list_count(inputs)
});